import { getDataLinkAttributes } from "@/helpers";
import { FC } from "react";
import { Card, Media } from "@/types/General";
import Link from "@/components/Link";
import Image from "next/image";

type IntegrationCardProps = {
  type?: string;
  media?: Media;
} & Extract<Card, { type: "Integration" }>;

export const IntegrationCard: FC<IntegrationCardProps> = (props) => {
  return (
    <Link
      data-automation-group="card"
      className="focus-visible:bg-background focus-visible:outline-swdc-blue-400 bg-background-highlight border-symbol-silver-300-graphic group hover:border-swdc-gray-300 flex flex-col items-start gap-2 self-stretch border px-4 pt-4 pb-8 outline-2 outline-offset-0 outline-transparent hover:shadow-[0_10px_20px_0px_rgba(0,0,0,0.10)]"
      href={props.link?.url || "#"}
      {...getDataLinkAttributes(props.link)}
    >
      {props.media?.type === "image" && (
        <Image
          src={props.media.image}
          alt={`${props.title} Card Image`}
          width={56}
          height={56}
          loader={({ src }) => src}
          className="h-14 w-auto max-w-full object-contain"
        />
      )}
      <div className="flex flex-col gap-2">
        <div
          role="heading"
          aria-level={4}
          aria-label={`${props.type}: ${props.title}`}
          className="text-tab-link text-body-s sm:text-body-m md:text-body-l group-active:text-tab-link-pressed font-bold group-hover:underline"
        >
          {props.title}
        </div>
        <div
          className="text-body-primary text-link-s leading-5"
          dangerouslySetInnerHTML={{ __html: props.description }}
        />
      </div>
    </Link>
  );
};
